// 表示矩形（ビューポートのステージ座標表現）と、各オブジェクトの AABB を交差判定して
// 描画対象を絞り込むための補助関数。
//
// 性能観点:
// - 5,000 オブジェクト hard limit を踏まえても線形フィルタで毎フレーム十分高速。
// - rotation 中の object は AABB が若干広がるため、`pad` を加えた拡張矩形で交差判定する。

import type { ViewState } from "./canvas-coordinates";

export interface Aabb {
  readonly x: number;
  readonly y: number;
  readonly w: number;
  readonly h: number;
}

/**
 * 現在のビューポート（screen 全体）が、ステージ座標でどの矩形に対応するかを返す。
 * pad 引数は描画余白で、rotation を持つ object のはみ出し対策に使う。
 */
export function viewportInStage(
  view: ViewState,
  viewportWidth: number,
  viewportHeight: number,
  pad = 0
): Aabb {
  // pan=0 のとき `-0 / zoom` が `-0` を返すため、`+ 0` で `+0` に正規化する。
  const x = -view.panX / view.zoom - pad + 0;
  const y = -view.panY / view.zoom - pad + 0;
  const w = viewportWidth / view.zoom + pad * 2;
  const h = viewportHeight / view.zoom + pad * 2;
  return { x, y, w, h };
}

/** 2 つの AABB が交差するかを返す。境界共有も交差扱い。 */
export function aabbIntersects(a: Aabb, b: Aabb): boolean {
  return (
    a.x <= b.x + b.w &&
    a.x + a.w >= b.x &&
    a.y <= b.y + b.h &&
    a.y + a.h >= b.y
  );
}
